import { createSelector } from 'reselect';
import {
  IFacilityShiftListState,
  IShiftHistoryState,
  IShiftStatisticsState,
  ITodayShiftStatisticsState,
  IShiftDetailsState,
  ICancelShiftState,
  IUpdateShiftAttendanceState,
  IOngoingShiftListState,
  IForceCancelShiftState,
  IOrganizationClockInState,
  IOrganizationClockOutState,
  IMonitoringShiftState,
  IShiftRequestListState,
  IFacilityShiftRequestListState,
  IUpdateShiftRequestStatusState,
  ICompleteShiftRequestState,
  ICancelShiftRequestState,
  ICancellationWarningState,
  IValidateWorkerShiftTimingState,
  IShiftBoardStatsState,
} from './types';


const selectShiftDetailsState = (state: { shiftDetails: IShiftDetailsState }) => state.shiftDetails;

export const selectShiftDetails = createSelector(
  selectShiftDetailsState,
  (shiftDetails) => shiftDetails.data,
);

export const selectShiftDetailsLoading = createSelector(
  selectShiftDetailsState,
  (shiftDetails) => shiftDetails.loading,
);

export const selectShiftDetailsError = createSelector(
  selectShiftDetailsState,
  (shiftDetails) => shiftDetails.error,
);

const selectTodayShiftStatisticsState = (state: {
  todayShiftStatistics: ITodayShiftStatisticsState;
}) => state.todayShiftStatistics;

export const selectTodayShiftStatistics = createSelector(
  selectTodayShiftStatisticsState,
  (todayShiftStatistics) => todayShiftStatistics.statistics,
);

export const selectTodayShiftStatisticsLoading = createSelector(
  selectTodayShiftStatisticsState,
  (todayShiftStatistics) => todayShiftStatistics.loading,
);

export const selectTodayShiftStatisticsError = createSelector(
  selectTodayShiftStatisticsState,
  (todayShiftStatistics) => todayShiftStatistics.error,
);

const selectShiftStatisticsState = (state: {
  shiftStatistics: IShiftStatisticsState;
}) => state.shiftStatistics;

export const selectShiftStatistics = createSelector(
  selectShiftStatisticsState,
  (shiftStatistics) => shiftStatistics.statistics,
);

export const selectShiftStatisticsLoading = createSelector(
  selectShiftStatisticsState,
  (shiftStatistics) => shiftStatistics.loading,
);

export const selectShiftStatisticsError = createSelector(
  selectShiftStatisticsState,
  (shiftStatistics) => shiftStatistics.error,
);

const selectFacilityShiftListState = (state: { facilityShiftList: IFacilityShiftListState }) => state.facilityShiftList;

export const selectFacilityShiftLists = createSelector(
  selectFacilityShiftListState,
  (facilityShiftList) => facilityShiftList.list.results
);

export const selectFacilityShiftsListsLoading = createSelector(
  selectFacilityShiftListState,
  (facilityShiftList) => facilityShiftList.loading
);

export const selectFacilityShiftsError = createSelector(
  selectFacilityShiftListState,
  (facilityShiftList) => facilityShiftList.error
);

export const selectFacilityShiftsCount = createSelector(
  selectFacilityShiftListState,
  (facilityShiftList) => facilityShiftList.list.count
);

const selectOrgFacilityPendingShiftsState = (state: { orgFacilityPendingShifts: IFacilityShiftListState }) => state.orgFacilityPendingShifts;

export const selectOrgFacilityPendingShiftsLists = createSelector(
  selectOrgFacilityPendingShiftsState,
  (orgFacilityPendingShifts) => orgFacilityPendingShifts.list.results
);

export const selectOrgFacilityPendingShiftsLoading = createSelector(
  selectOrgFacilityPendingShiftsState,
  (orgFacilityPendingShifts) => orgFacilityPendingShifts.loading
);

export const selectOrgFacilityPendingShiftsError = createSelector(
  selectOrgFacilityPendingShiftsState,
  (orgFacilityPendingShifts) => orgFacilityPendingShifts.error
);

export const selectOrgFacilityPendingShiftsCount = createSelector(
  selectOrgFacilityPendingShiftsState,
  (orgFacilityPendingShifts) => orgFacilityPendingShifts.list.count
);

const selectAllShiftsState = (state: { allShifts: IShiftHistoryState }) => state.allShifts;

export const selectAllShifts = createSelector(
  selectAllShiftsState,
  (allShifts) => allShifts.results
);

export const selectAllShiftsLoading = createSelector(
  selectAllShiftsState,
  (allShifts) => allShifts.loading
);

export const selectAllShiftsError = createSelector(
  selectAllShiftsState,
  (allShifts) => allShifts.error
);

export const selectAllShiftsCount = createSelector(
  selectAllShiftsState,
  (allShifts) => allShifts.count
);

export const selectAllShiftsNext = createSelector(
  selectAllShiftsState,
  (allShifts) => allShifts.next
);

export const selectAllShiftsPrevious = createSelector(
  selectAllShiftsState,
  (allShifts) => allShifts.previous
);

const selectCancelShiftState = (state: { cancelShift: ICancelShiftState }) => state.cancelShift;

export const selectCancelShiftLoading = createSelector(
  selectCancelShiftState,
  (cancelShift) => cancelShift.loading,
);

export const selectCancelShiftSuccess = createSelector(
  selectCancelShiftState,
  (cancelShift) => cancelShift.success,
);

export const selectCancelShiftError = createSelector(
  selectCancelShiftState,
  (cancelShift) => cancelShift.error,
);

export const selectCancelShiftMessage = createSelector(
  selectCancelShiftState,
  (cancelShift) => cancelShift.message,
);

const selectUpdateShiftAttendanceState = (state: { updateShiftAttendance: IUpdateShiftAttendanceState }) => state.updateShiftAttendance;

export const selectUpdateShiftAttendanceLoading = createSelector(
  selectUpdateShiftAttendanceState,
  (updateShiftAttendance) => updateShiftAttendance.loading,
);

export const selectUpdateShiftAttendanceSuccess = createSelector(
  selectUpdateShiftAttendanceState,
  (updateShiftAttendance) => updateShiftAttendance.success,
);

export const selectUpdateShiftAttendanceError = createSelector(
  selectUpdateShiftAttendanceState,
  (updateShiftAttendance) => updateShiftAttendance.error,
);



export const selectUpdateShiftAttendanceMessage = createSelector(

  selectUpdateShiftAttendanceState,

  (updateShiftAttendance) => updateShiftAttendance.message,

);



const selectOngoingShiftsState = (state: {

  ongoingShifts: IOngoingShiftListState;

}) => state.ongoingShifts;



export const selectOngoingShifts = createSelector(

  selectOngoingShiftsState,

  (ongoingShifts) => ongoingShifts.list.results,

);



export const selectOngoingShiftsLoading = createSelector(

  selectOngoingShiftsState,

  (ongoingShifts) => ongoingShifts.loading,

);



export const selectOngoingShiftsError = createSelector(

  selectOngoingShiftsState,

  (ongoingShifts) => ongoingShifts.error,

);



export const selectOngoingShiftsCount = createSelector(

  selectOngoingShiftsState,

  (ongoingShifts) => ongoingShifts.list.count,

);



export const selectOngoingShiftsNext = createSelector(

  selectOngoingShiftsState,

  (ongoingShifts) => ongoingShifts.list.next,

);



export const selectOngoingShiftsPrevious = createSelector(

  selectOngoingShiftsState,

  (ongoingShifts) => ongoingShifts.list.previous,
);

const selectForceCancelShiftState = (state: { forceCancelShift: IForceCancelShiftState }) => state.forceCancelShift;

export const selectForceCancelShiftLoading = createSelector(
  selectForceCancelShiftState,
  (forceCancelShift) => forceCancelShift.loading,
);

export const selectForceCancelShiftSuccess = createSelector(
  selectForceCancelShiftState,
  (forceCancelShift) => forceCancelShift.success,
);

export const selectForceCancelShiftError = createSelector(
  selectForceCancelShiftState,
  (forceCancelShift) => forceCancelShift.error,
);

export const selectForceCancelShiftMessage = createSelector(
  selectForceCancelShiftState,
  (forceCancelShift) => forceCancelShift.message,
);

const selectMonitoringShiftsState = (state: { monitoringShifts: IMonitoringShiftState }) => state.monitoringShifts;

export const selectMonitoringShifts = createSelector(
  selectMonitoringShiftsState,
  (monitoringShifts) => monitoringShifts.data.results,
);

export const selectMonitoringShiftsCount = createSelector(
  selectMonitoringShiftsState,
  (monitoringShifts) => monitoringShifts.data.count,
);

export const selectMonitoringShiftsLoading = createSelector(
  selectMonitoringShiftsState,
  (monitoringShifts) => monitoringShifts.loading,
);

export const selectMonitoringShiftsError = createSelector(
  selectMonitoringShiftsState,
  (monitoringShifts) => monitoringShifts.error,
);

export const selectMonitoringShiftsNext = createSelector(
  selectMonitoringShiftsState,
  (monitoringShifts) => monitoringShifts.data.next,
);

const selectShiftRequestsState = (state: { shiftRequests: IShiftRequestListState }) => state.shiftRequests;

export const selectShiftRequests = createSelector(
  selectShiftRequestsState,
  (shiftRequests) => shiftRequests.list.results,
);

export const selectShiftRequestsCount = createSelector(
  selectShiftRequestsState,
  (shiftRequests) => shiftRequests.list.count,
);

export const selectShiftRequestsLoading = createSelector(
  selectShiftRequestsState,
  (shiftRequests) => shiftRequests.loading,
);

export const selectShiftRequestsError = createSelector(
  selectShiftRequestsState,
  (shiftRequests) => shiftRequests.error,
);

export const selectShiftRequestsNext = createSelector(
  selectShiftRequestsState,
  (shiftRequests) => shiftRequests.list.next,
);

export const selectShiftRequestsPrevious = createSelector(
  selectShiftRequestsState,
  (shiftRequests) => shiftRequests.list.previous,
);

const selectFacilityShiftRequestsState = (state: { facilityShiftRequests: IFacilityShiftRequestListState }) => state.facilityShiftRequests;

export const selectFacilityShiftRequests = createSelector(
  selectFacilityShiftRequestsState,
  (facilityShiftRequests) => facilityShiftRequests.list.results,
);

export const selectFacilityShiftRequestsCount = createSelector(
  selectFacilityShiftRequestsState,
  (facilityShiftRequests) => facilityShiftRequests.list.count,
);

export const selectFacilityShiftRequestsLoading = createSelector(
  selectFacilityShiftRequestsState,
  (facilityShiftRequests) => facilityShiftRequests.loading,
);

export const selectFacilityShiftRequestsError = createSelector(
  selectFacilityShiftRequestsState,
  (facilityShiftRequests) => facilityShiftRequests.error,
);

export const selectFacilityShiftRequestsNext = createSelector(
  selectFacilityShiftRequestsState,
  (facilityShiftRequests) => facilityShiftRequests.list.next,
);

export const selectFacilityShiftRequestsPrevious = createSelector(
  selectFacilityShiftRequestsState,
  (facilityShiftRequests) => facilityShiftRequests.list.previous,
);

const selectUpdateShiftRequestStatusState = (state: { updateShiftRequestStatus: IUpdateShiftRequestStatusState }) => state.updateShiftRequestStatus;

export const selectUpdateShiftRequestStatusLoading = createSelector(
  selectUpdateShiftRequestStatusState,
  (updateShiftRequestStatus) => updateShiftRequestStatus.loading,
);

export const selectUpdateShiftRequestStatusSuccess = createSelector(
  selectUpdateShiftRequestStatusState,
  (updateShiftRequestStatus) => updateShiftRequestStatus.success,
);

export const selectUpdateShiftRequestStatusError = createSelector(
  selectUpdateShiftRequestStatusState,
  (updateShiftRequestStatus) => updateShiftRequestStatus.error,
);

export const selectUpdateShiftRequestStatusMessage = createSelector(
  selectUpdateShiftRequestStatusState,
  (updateShiftRequestStatus) => updateShiftRequestStatus.message,
);

const selectCompleteShiftRequestState = (state: { completeShiftRequest: ICompleteShiftRequestState }) => state.completeShiftRequest;

export const selectCompleteShiftRequestLoading = createSelector(
  selectCompleteShiftRequestState,
  (completeShiftRequest) => completeShiftRequest.loading,
);

export const selectCompleteShiftRequestSuccess = createSelector(
  selectCompleteShiftRequestState,
  (completeShiftRequest) => completeShiftRequest.success,
);

export const selectCompleteShiftRequestError = createSelector(
  selectCompleteShiftRequestState,
  (completeShiftRequest) => completeShiftRequest.error,
);

export const selectCompleteShiftRequestMessage = createSelector(
  selectCompleteShiftRequestState,
  (completeShiftRequest) => completeShiftRequest.message,
);

const selectCancelShiftRequestState = (state: { cancelShiftRequest: ICancelShiftRequestState }) => state.cancelShiftRequest;

export const selectCancelShiftRequestLoading = createSelector(
  selectCancelShiftRequestState,
  (cancelShiftRequest) => cancelShiftRequest.loading,
);

export const selectCancelShiftRequestSuccess = createSelector(
  selectCancelShiftRequestState,
  (cancelShiftRequest) => cancelShiftRequest.success,
);

export const selectCancelShiftRequestError = createSelector(
  selectCancelShiftRequestState,
  (cancelShiftRequest) => cancelShiftRequest.error,
);

export const selectCancelShiftRequestMessage = createSelector(
  selectCancelShiftRequestState,
  (cancelShiftRequest) => cancelShiftRequest.message,
);

const selectCancellationWarningState = (state: { cancellationWarning: ICancellationWarningState }) => state.cancellationWarning;

export const selectCancellationWarningData = createSelector(
  selectCancellationWarningState,
  (state) => state.data,
);

export const selectCancellationWarningLoading = createSelector(
  selectCancellationWarningState,
  (state) => state.loading,
);

export const selectCancellationWarningError = createSelector(
  selectCancellationWarningState,
  (state) => state.error,
);

const selectValidateWorkerShiftTimingState = (state: { validateWorkerShiftTiming: IValidateWorkerShiftTimingState }) => state.validateWorkerShiftTiming;

export const selectValidateWorkerShiftTimingData = createSelector(
  selectValidateWorkerShiftTimingState,
  (state) => state.data,
);

export const selectValidateWorkerShiftTimingLoading = createSelector(
  selectValidateWorkerShiftTimingState,
  (state) => state.loading,
);

export const selectValidateWorkerShiftTimingError = createSelector(
  selectValidateWorkerShiftTimingState,
  (state) => state.error,
);

const selectShiftBoardStatsState = (state: { shiftBoardStats: IShiftBoardStatsState }) => state.shiftBoardStats;

export const selectShiftBoardStatsData = createSelector(
  selectShiftBoardStatsState,
  (state) => state.data,
);

export const selectShiftBoardStatsLoading = createSelector(
  selectShiftBoardStatsState,
  (state) => state.loading,
);

export const selectShiftBoardStatsError = createSelector(
  selectShiftBoardStatsState,
  (state) => state.error,
);

const selectOrganizationClockInState = (state: { organizationClockIn: IOrganizationClockInState }) => state.organizationClockIn;

export const selectOrganizationClockInLoading = createSelector(
  selectOrganizationClockInState,
  (state) => state.loading,
);

export const selectOrganizationClockInSuccess = createSelector(
  selectOrganizationClockInState,
  (state) => state.success,
);

export const selectOrganizationClockInError = createSelector(
  selectOrganizationClockInState,
  (state) => state.error,
);

export const selectOrganizationClockInMessage = createSelector(
  selectOrganizationClockInState,
  (state) => state.message,
);

const selectOrganizationClockOutState = (state: { organizationClockOut: IOrganizationClockOutState }) => state.organizationClockOut;

export const selectOrganizationClockOutLoading = createSelector(
  selectOrganizationClockOutState,
  (state) => state.loading,
);

export const selectOrganizationClockOutSuccess = createSelector(
  selectOrganizationClockOutState,
  (state) => state.success,
);

export const selectOrganizationClockOutError = createSelector(
  selectOrganizationClockOutState,
  (state) => state.error,
);

export const selectOrganizationClockOutMessage = createSelector(
  selectOrganizationClockOutState,
  (state) => state.message,
);
